import React from 'react';

import { Routes, Route, BrowserRouter} from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Home from "./home/home";
import CompanyInfo from "./aboutUs/CompanyInfo"
import AppContext from "./AppContext";
import CompanyVision from "./aboutUs/CompanyVision";
import NewsEvent from "./newsAndEvent/NewsEvent";
import Service from "./service/Service";
import ContactUs from "./contactUs/ContactUs";

function App() {
    return (
        <AppContext>
            <BrowserRouter>
                <div className="app">
                    <Header/>
                    <Routes>
                        <Route path="/" element={<Home />}/>
                        <Route path="/company-info" element={<CompanyInfo />}/>
                        <Route path="/our-vision" element={<CompanyVision />}/>
                        <Route path="/service" element={<Service />} />
                        <Route path="/news-event" element={<NewsEvent />} />
                        <Route path="/contact-us" element={<ContactUs />} />
                    </Routes>
                    <Footer/>
                </div>
            </BrowserRouter>
        </AppContext>
    );
}

export default App;
